import { Container, Sprite } from '@pixi/react';
import { useLayoutEffect, useRef } from 'react';
import { isMobile } from '../../../helpers/isMobile';
import { getGameImages } from '../../../helpers/getGameImages';
import { winPanelHostByGameId } from '../../../constants/enumsByGames';
import { gameConfigurationStore } from '../../store/gameConfigurationStore';

export const GameBoard = () => {
  const { gameBoard } = getGameImages();
  const winPanelHostRef = useRef(null);
  const winPanelHost = winPanelHostByGameId[gameConfigurationStore.gameId];

  const containerConfig = {
    x: isMobile() ? 0 : 161.5,
    y: isMobile() ? 186 : 0,
  };

  // RU: хост табло Win / Last Win ядра: ядро одалживает ему узел табло (`lendToHost`) и забирает домой
  //     по его `destroyed`; здесь только точка у нижнего края доски. Слой снимается с уходом борда.
  useLayoutEffect(() => {
    if (!winPanelHost) return undefined;
    gameConfigurationStore.setWinLastWinLayer(winPanelHostRef.current);
    return () => gameConfigurationStore.setWinLastWinLayer(null);
  }, [winPanelHost]);

  return (
    <Container {...containerConfig} name='GameBoardContainer'>
      <Sprite anchor={0} texture={gameBoard} />
      {winPanelHost && (
        <Container ref={winPanelHostRef} {...winPanelHost} eventMode='none' name='WinPanelHost' />
      )}
    </Container>
  );
};
